import React from 'react'
import { Link } from 'react-router-dom'

import './Footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__wrapper columns valign-top">
                <div className="footer__links column-half align-left mobile-margin-bottom">
                    <h3>Liens utiles</h3>
                    <ul className="no-prefix">
                        <li>
                            <p className="light">
                                Les mentions légales et<br />les politique de confidentialité<br />
                                sont disponible sur le <Link className="link" to={`${process.env.PUBLIC_URL}/plan-du-site`}>Plan du site</Link>
                            </p>
                        </li>
                        {/* <li><p className="light"><Link className="link" to={`${process.env.PUBLIC_URL}/articles`}>Notre actualité</Link></p></li> */}
                        {/* <li><p className="light"><Link className="link" to={`${process.env.PUBLIC_URL}/mentions`}>Mentions légales</Link></p></li> */}
                        {/* <li><p className="light"><Link className="link" to={`${process.env.PUBLIC_URL}/plan-du-site`}>Plan du site</Link></p></li> */}
                        {/* <li><p className="light"><Link className="link" to={`${process.env.PUBLIC_URL}/faq`}>Questions fréquentes</Link></p></li> */}
                        {/* <li><p className="light"><Link className="link" to={`${process.env.PUBLIC_URL}/styleguide`}>Styleguide</Link></p></li> */}
                    </ul>
                </div>
                <div className="footer__contact column-half align-left">
                    <h3>Vous avez une idée, un besoin&nbsp;?</h3>
                    <p>On en parle par mail, téléphone ou autour d’un café à Arras.</p>
                    <p className="mail">
                        <Link className="link" to="mailto:mdournel@bigetnouf.fr">mdournel@bigetnouf.fr</Link> / <Link className="link" to="tel:+33695179184">06&nbsp;95&nbsp;17&nbsp;91&nbsp;84</Link><br />
                        <Link className="link" to="mailto:fbeaumont@bigetnouf.fr">fbeaumont@bigetnouf.fr</Link> / <Link className="link" to="tel:+33632761395">06&nbsp;32&nbsp;76&nbsp;13&nbsp;95</Link>
                    </p>
                    {/* <p>
                        <Link to="https://www.linkedin.com/company/big-et-nouf/" className="social link__icon" title="LinkedIn"><Icon version="linkedin" /></Link>
                        <Link to="https://www.instagram.com/big.et.nouf/" className="social link__icon" title="Instagram"><Icon version="instagram" /></Link>
                        <Link to="https://www.facebook.com/big.et.nouf/" className="social link__icon" title="Facebook"><Icon version="facebook" /></Link>
                    </p> */}
                </div>
                <div className="footer__mentions column-full align-center">
                    <p className="light">Copyright&nbsp;: © 2023-{new Date().getFullYear()} BIG et Nouf – Sites web utiles & sensibles.</p>
                    <p className="light">Musées, culture et tourisme&nbsp;: <Link className="link" to="https://reflet-reflet.fr" target="_blank" rel="noreferrer noopener">Reflet-Reflet.fr</Link>.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer